'use strict';
const angular = require('angular');

export class MessageSideBarComponent {
  menu = [{
    title: 'Home',
    url: 'main'
  }];

  isCollapsed = true;

  constructor(FB, $firebaseAuth, $state, $stateParams, $cookies, $scope, $rootScope, navService, fetch, $timeout) {
    'ngInject';

    this.isLoggedIn = FB.isLoggedInSync;
    this.getCurrentUser = FB.getCurrentUserSync;
    this.$firebaseAuth = $firebaseAuth();
    this.$state = $state;
    this.$cookies = $cookies;
    this.isAdmin = FB.isAdminSync;
    this.navService = navService;
    this.$scope = $scope;
    this.fetch = fetch;
    this.$stateParams = $stateParams;
    this.$timeout = $timeout;

    $scope.breadcrumb = navService.getBreadCrumb();


  }

  $onInit() {
    this.isOpen = false;
    this.messages = [];
    this.unreadCount = 0;
  }

  toggleSidebar = () => {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      // this.fetchMessages();
    }
  };

  submitReply($event) {
    if ($event) {
      $event.preventDefault();
    }

    const now = new Date();

    if (!this.replyMessage) {
      return;
    }

    if (!this.messageType || !this.replyMessage ||
      this.replyMessage.length > 500) return;

    const messageData = {
      comment: this.replyMessage,
      message_type: this.messageType,
      to_jurisdiction: this.$scope.currentJurisdiction,
      submission_id: this.$scope.submissionId,
      created_at: now.toISOString()
    };

    console.log(messageData);

    // Only include submissionId if it exists
    // if (this.$stateParams.submissionId) {
    //   messageData.submission_id = this.$stateParams.submissionId;
    // }

    
    // const reply = {
    //   submission_id: this.$stateParams.submissionId,
    //   from: this.currentUser.id,
    //   comment: this.replyMessage,
    //   created_at: now.toISOString(),
    //   message_type: this.messageType
    // };



    this.fetch.updateItem('api/messages', messageData)
      .then(response => {
        console.log('Reply sent:', response.data);
        this.replyMessage = null;
        this.messageType = null;

        // Refresh the messages list
        //  this.$state.go(this.previousState);
        this.toggleSidebar();
      })
      .catch(err => {
        console.error('Error sending reply:', err);
        this.$timeout(() => {
          this.error = 'Failed to send reply';
        });
      });
  }

}

export default angular.module('appApp.messagesidebar', [])
  .directive('messagesidebar', function () {
    return {
      template: require('./messagesidebar.html'),
      controller: MessageSideBarComponent,
      controllerAs: 'messagesidebarCtrl',
      restrict: 'EA',
      link: function (scope, element, attrs) { }
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/directives/messagesidebar/messagesidebar.directive.js